import { FRAME_PROCESSOR_ERROR_CODES } from '../constants/frame-processor-constants';
export function createError(code: string, message: string, originalError?: unknown): Error {
  const details = originalError instanceof Error ? originalError.message : '';
  return new Error(`${code}: ${message}${details ? ` (${details})` : ''}`);
}
function extractErrorCode(errorMessage: string): string {
  const colonIndex = errorMessage.indexOf(':');
  if (colonIndex > 0) {
    return errorMessage.substring(0, colonIndex).trim();
  }
  return errorMessage.trim();
}
export function getClientErrorMessage(errorMessage: string): string {
  const errorCode = extractErrorCode(errorMessage);
  switch (errorCode) {
    // Demuxer errors - shown when falling back to FPS-based timing
    case FRAME_PROCESSOR_ERROR_CODES.NO_VIDEO_TRACK:
    case FRAME_PROCESSOR_ERROR_CODES.INCOMPLETE_VIDEO_DOWNLOAD:
    case FRAME_PROCESSOR_ERROR_CODES.VIDEO_FETCH_ERROR:
    case FRAME_PROCESSOR_ERROR_CODES.VIDEO_STREAM_ERROR:
    case FRAME_PROCESSOR_ERROR_CODES.VIDEO_STREAM_READ_ERROR:
    case FRAME_PROCESSOR_ERROR_CODES.VIDEO_PARSE_ERROR:
      return 'Unable to process video frames accurately. Frame timing may be less precise.';
    case FRAME_PROCESSOR_ERROR_CODES.DEMUX_ABORTED:
      return '';

    // Decoder errors - shown when a specific frame fails to decode
    case FRAME_PROCESSOR_ERROR_CODES.VIDEO_NOT_READY:
    case FRAME_PROCESSOR_ERROR_CODES.FRAME_NOT_IN_CACHE:
    case FRAME_PROCESSOR_ERROR_CODES.FRAME_DATA_ERROR:
    case FRAME_PROCESSOR_ERROR_CODES.DECODER_ERROR:
    case FRAME_PROCESSOR_ERROR_CODES.DECODER_CONFIGURATION_ERROR:
    case FRAME_PROCESSOR_ERROR_CODES.KEYFRAME_NOT_FOUND:
    case FRAME_PROCESSOR_ERROR_CODES.VIDEO_CHUNK_CREATION_ERROR:
    case FRAME_PROCESSOR_ERROR_CODES.DECODE_CHUNKS_ERROR:
    case FRAME_PROCESSOR_ERROR_CODES.FLUSH_ERROR:
      return 'Could not load precise frame. Showing approximate frame instead.';
    default:
      return 'An error occurred while processing video frames.';
  }
}